// extracted by mini-css-extract-plugin
module.exports = {"root":"Chapter_root__341B9","title":"Chapter_title__9zV6v","image":"Chapter_image__2htOr"};